/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/test-ids';
import { EnterpriseIcon } from '@trello/nachos/icons/enterprise';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { State } from 'app/gamma/src/modules/types';
import React, { Suspense, FunctionComponent, useCallback } from 'react';
import { connect } from 'react-redux';
import { isEnterpriseAdmin } from 'app/gamma/src/selectors/enterprises';
import HeaderButton from './button';
import { usePopover, Popover } from '@trello/nachos/popover';
import { forNamespace } from 'app/common/lib/util/i18n';
import { useLazyComponent } from '@trello/use-lazy-component';

const viewTitle = forNamespace('view title');

interface StateProps {
  isAdmin: boolean;
}

const EnterpriseMenuButton: FunctionComponent<StateProps> = ({ isAdmin }) => {
  const EnterpriseMenu = useLazyComponent(() =>
    import(
      /* webpackChunkName: "enterprise-menu-popover" */ 'app/gamma/src/components/popovers/enterprise-menu'
    ),
  );

  const { toggle, hide, triggerRef, popoverProps } = usePopover<
    HTMLButtonElement
  >();
  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ENTERPRISE_DASHBOARD_MENU,
      method: 'by clicking enterprise button in header',
    });
    toggle();
  }, [toggle]);
  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <HeaderButton
        icon={<EnterpriseIcon color="light" />}
        onClick={onClick}
        ref={triggerRef}
        testId={HeaderTestIds.EnterpriseDashboardButton}
        ariaLabel={viewTitle('trello enterprise')}
      />
      <Popover {...popoverProps} title={viewTitle('trello enterprise')}>
        <Suspense fallback={null}>
          <EnterpriseMenu onEnterpriseSelected={hide} />
        </Suspense>
      </Popover>
    </>
  );
};

const mapStateToProps = (state: State): StateProps => ({
  isAdmin: isEnterpriseAdmin(state),
});

export default connect(mapStateToProps)(EnterpriseMenuButton);
